import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { css } from 'glamor'
import Toast from '../toast/Toast'

import "./style.scss";
import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss';


export class Plant extends React.Component {

  constructor(props){
    super(props)

    const interactions = (heldObj, target) => {
      //Don't run if this plant not the held object
      if(heldObj.type !== "Plant" || heldObj.id !== this.props.id){
        return null;
      }
      if (target === undefined || target === null) {
        return null;
      }
      //All GlassTube interactions
      if (target.type === "GlassTube") {
        //Get the targeted GlassTube
        const tubeID = target.id
        const targetGlassTube = this.props.interactionProps.glassTubes[tubeID - 1]

        if(targetGlassTube.stopperId !== -1) {
          this.makeToast("WARNING", "You must open the glass tube first.", "Glass Tube is closed!");
          return null;
        }

        if(targetGlassTube.plantId !== -1) {
          this.makeToast("WARNING", "This glass tube already contains a plant.", "Glass Tube is full!");
          return null;
        }

        this.props.onDropPlant({
          plantId: this.props.id,
          tubeID: targetGlassTube.id,
          type: "plant"
        })

        this.props.setPlantsInScene({
          id: this.props.id,
          inScene: false
        });

        // Reset the tube position to a zero transform
        heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"

      } else {
        return null
      }
    }
    Object.defineProperty(interactions, 'name', {value: ('plant_interactions_'+this.props.id), configurable: true});
    this.props.pushInteractions([interactions])
  }



  componentWillMount() {
    this.props.createPlant({
      props: this.props.defaultProps,
    });
  }
  plantSelected = (e) => {

    this.props.setPlantHeld({
      id: this.props.id,
      held: true,
    })
    this.props.setHeldObject({
      id: this.props.id,
      type: "Plant",
      htmlObj: e.target,
    });
    if(!this.props.controlsVisible){
      this.showControls()
  }
  }

  plantUnselected = (e) => {
    this.props.setPlantHeld({
      id: this.props.id,
      held: false,
    })
  }
  makeToast = (type, msg, title) => {
    let color = ""
    if(type==="HINT"){
      color = colors.yellow1
    } else {
      color = colors.red1
    }

    toast(<Toast type={type} msg={msg} title={title} />,{
      className: css({
        border: "2px solid "+color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000,
    });
  }
  showControls = ()=> {
    this.props.hideAllControls();
    this.props.setPlantControlVisibility({id: this.props.id, controlsVisible: true});
  }
  render() {
    return (
      <ul style={{
        visibility: !this.props.inScene ? "hidden" : null,
        zIndex: this.props.controlsVisible ? 99 : null,
        padding: 0,
        margin: 0
      }}>
        <li
          id={"Plant_"+this.props.id}
          className={'Plant draggable'}
          onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.plantSelected() } }
          onDragStart={(e) => this.plantSelected(e)}
          onDragEnd={(e) => this.plantUnselected(e)}
          draggable
          tabIndex={0}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

Plant.propTypes = {
  createPlant: PropTypes.func,
};

Plant.defaultProps = {};
